import { Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import styled from 'styled-components';

const StyledFormInput = styled.input`
  padding: 0 35px;
  height: ${(props) => (props.isMobile ? '37px' : '54px')};
  width: ${(props) => (props.wid || props.isMobile ? '246px' : '410px')};
  border-radius: 26px;
  background-color: #fff;
  text-align: ${(props) => (props.alignLeft ? 'left' : 'center')};
  font-family: CeraPro;
  font-weight: 400;
  font-size: ${(props) => (props.isMobile ? '18px' : '22px')};

  ::placeholder {
    color: ${(props) => props.placeholderCol || theme.PRIMARY_BLACK};
  }

  :-ms-input-placeholder {
    color: ${(props) => props.placeholderCol || theme.PRIMARY_BLACK};
  }

  ::-ms-input-placeholder {
    color: ${(props) => props.placeholderCol || theme.PRIMARY_BLACK};
  }

  ${(props) =>
    props.password &&
    props.value.length &&
    `
    letter-spacing: 5px;
  `}

  @media (max-width: 1024px) {
    padding: 0 20px;
  }
`;

const FormInput = (props) => {
  const { isMobile } = global;
  const err = typeof props.err === 'object' ? props.err.err : props.err;

  if (props.website)
    return (
      <React.Fragment>
        <StyledFormInput
          {...props}
          type={props.password && 'password'}
          placeholderTextColor={theme.PRIMARY_BLACK}
          isMobile={isMobile}
        />

        {err && (
          <Text size="16px" marg="5px 0 0" weight="500" col={theme.SECONDARY} ref={props.inputRef}>
            {err}
          </Text>
        )}
      </React.Fragment>
    );

  return (
    <React.Fragment>
      <StyledFormInput
        {...props}
        type={props.password && 'password'}
        placeholderTextColor={theme.PRIMARY_BLACK}
        isMobile={isMobile}
      />

      {err && (
        <Text size="16px" marg="5px 0 0" weight="500" col={theme.SECONDARY}>
          {err}
        </Text>
      )}
    </React.Fragment>
  );
};

export default FormInput;
